import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { HTTPValidationError, ISiteUpdate, ISuccessfulResponse } from 'src/types/SiteStudyPersonal';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sitesApi = createApi({
  baseQuery,
  reducerPath: 'sitesApi',
  endpoints: builder => ({
    getAllSites: builder.query<string[], void>({
      query: () => ({ url: endPoints.Site.getAll }),
      extraOptions: { maxRetries: 3 },
      transformResponse: (response: string[]) => (response ? response.sort() : response)
    }),
    updateSite: builder.mutation<ISuccessfulResponse | HTTPValidationError, ISiteUpdate>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: formatString(
          endPoints.Site.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.country, value: country },
          { key: urlKeys.application, value: application }
        ),
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getUserClicks: builder.query<any, any>({
      query: () => ({ url: endPoints.UserClicks.select }),
      extraOptions: { maxRetries: 3 }
    }),
    createUserClick: builder.mutation<ISuccessfulResponse | HTTPValidationError, { data: any }>({
      query: ({ data }) => ({
        url: formatString(endPoints.UserClicks.create),
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 } //add this for retry option
    })
  })
});

export const { useGetAllSitesQuery, useUpdateSiteMutation, useGetUserClicksQuery, useCreateUserClickMutation } =
  sitesApi;
